
import { defineComponent, ref } from 'vue';
import lazyImage from '@/directives/lazyImage';

export default defineComponent({
  props: {
    url: { type: String, required: true },
    imageFitContain: { type: Boolean, default: false },
  },
  directives: {
    lazyImage,
  },
  setup() {
    const isLoaded = ref(false);
    const isError = ref(false);

    return {
      isLoaded,
      isError,
    };
  },
});
